import { useState } from 'react';
import IMAGES from '../images';
import './Contact.css';

import { douches, robinetsMuraux, robinetsAPoser, robinetsSuspendus, robinetsWC } from '../data/robinetterie';
import { vasquesMarbre, vasquesLaiton } from '../data/vasques';
import { porteSavons, porteServiettes, miroirs, bougeoirs, etagereDouche, porteBrosses, portesPapierToilette } from '../data/accessoires';

// ── Product Categories for Multi-Select ──
const PRODUCT_CATEGORIES = [
  {
    group: 'Robinetterie',
    subcategories: [
      { name: 'Douches', items: douches.map(p => p.name) },
      { name: 'Robinets Muraux', items: robinetsMuraux.map(p => p.name) },
      { name: 'Robinets à Poser', items: robinetsAPoser.map(p => p.name) },
      { name: 'Robinets Suspendus', items: robinetsSuspendus.map(p => p.name) },
      { name: 'Robinets WC', items: robinetsWC.map(p => p.name) },
    ],
  },
  {
    group: 'Vasques',
    subcategories: [
      { name: 'Vasques en Marbre', items: vasquesMarbre.map(p => p.name) },
      { name: 'Vasques en Laiton Martelé', items: vasquesLaiton.map(p => p.name) },
    ],
  },
  {
    group: 'Accessoires',
    subcategories: [
      { name: 'Porte-Savons', items: porteSavons.map(p => p.name) },
      { name: 'Porte-Serviettes', items: porteServiettes.map(p => p.name) },
      { name: 'Miroirs', items: miroirs.map(p => p.name) },
      { name: 'Bougeoirs', items: bougeoirs.map(p => p.name) },
      { name: 'Étagère de Douche', items: etagereDouche.map(p => p.name) },
      { name: 'Porte-Brosses', items: porteBrosses.map(p => p.name) },
      { name: 'Portes Papier Toilette', items: portesPapierToilette.map(p => p.name) },
      { name: "Produit d'Entretien", items: ["Produit d'Entretien"] },
    ],
  },
];

const SOURCE_OPTIONS = [
  'Instagram',
  'Facebook',
  'Bouche-à-oreille',
  'Magazine / Presse',
  'Salon / Exposition',
  'Autre',
];

export default function Contact() {
  const [form, setForm] = useState({
    name: '', email: '', phone: '', country: '',
    products: [],
    quantity: '', message: '', source: '',
  });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [expandedGroups, setExpandedGroups] = useState({});

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const toggleProduct = (product) => {
    setForm(prev => ({
      ...prev,
      products: prev.products.includes(product)
        ? prev.products.filter(p => p !== product)
        : [...prev.products, product],
    }));
  };

  const toggleGroup = (group) => {
    setExpandedGroups(prev => ({ ...prev, [group]: !prev[group] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);

    const body = `NOUVELLE DEMANDE DE DEVIS — Khansa Yazidi
==========================================
Nom       : ${form.name}
Email     : ${form.email}
Téléphone : ${form.phone || '-'}
Pays      : ${form.country || '-'}

PRODUITS SOUHAITÉS :
${form.products.length > 0 ? form.products.map(p => `✓ ${p}`).join('\n') : 'Aucun produit sélectionné'}

Quantité / Précisions :
${form.quantity || '-'}

Message :
${form.message}

Source : ${form.source || '-'}
==========================================
Envoyé depuis khansayazidi.tn`;

    // Automatically open the user's email client
    // Simulate slight delay for UI feedback
    setTimeout(() => {
      window.location.href = `mailto:yazidi.khansa@gmail.com?subject=${encodeURIComponent('Demande de Devis — ' + form.name)}&body=${encodeURIComponent(body)}`;
      setSending(false);
      setSent(true);
    }, 500);
  };


  return (
    <main className="cpage contact">
      {/* Universal Banner */}
      <div className="cpage__banner">
        <img src={IMAGES.devis} alt="Demande de Devis" className="cpage__banner-img" />
        <div className="cpage__banner-overlay" />
        <div className="cpage__banner-content">
          <span className="section-label">Restons en Contact</span>
          <h1 className="cpage__banner-title">Demander un Devis</h1>
          <div className="cpage__banner-divider" />
        </div>
      </div>

      <div className="contact__body">
        {/* Info Column */}
        <div className="contact__info">
          <div className="contact__info-block">
            <h3 className="contact__info-title">Showroom</h3>
            <p>87 Avenue Habib Bourguiba</p>
            <p>Ez-Zahra 2034, Tunisie</p>
          </div>
          <div className="contact__info-block">
            <h3 className="contact__info-title">Email</h3>
            <a href="mailto:yazidi.khansa@gmail.com">yazidi.khansa@gmail.com</a>
          </div>
          <div className="contact__info-block">
            <h3 className="contact__info-title">Téléphone</h3>
            <a href="tel:+21652428501">+216 52 428 501</a>
          </div>
          <div className="contact__info-block">
            <h3 className="contact__info-title">Horaires</h3>
            <p>Lundi – Samedi</p>
            <p>Sur Rendez-vous</p>
          </div>
          <div className="contact__info-block">
            <h3 className="contact__info-title">Réseaux</h3>
            <div className="contact__socials">
              <a href="https://instagram.com/yazidikhansa/" target="_blank" rel="noreferrer">Instagram</a>
              <a href="https://facebook.com/yazidikhansa/" target="_blank" rel="noreferrer">Facebook</a>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="contact__form-wrap">
          {sent ? (
            <div className="contact__success">
              <div className="contact__success-check">✓</div>
              <span className="section-label">Merci !</span>
              <h2 className="contact__success-title">Devis Généré</h2>
              <p>Votre demande de devis a bien été générée. Vous serez redirigé vers votre client mail.</p>
              <p className="contact__success-sub">À très bientôt chez Khansa Yazidi.</p>
            </div>
          ) : (
            <form className="contact__form" onSubmit={handleSubmit}>
              <h2 className="contact__form-title">Demande de Devis</h2>
              <div className="contact__form-divider" />

              {/* Name + Email */}
              <div className="contact__row">
                <div className="contact__field">
                  <label>Nom & Prénom *</label>
                  <input name="name" value={form.name} onChange={handleChange} required placeholder="Votre nom complet" />
                </div>
                <div className="contact__field">
                  <label>Email *</label>
                  <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="votre@email.com" />
                </div>
              </div>

              {/* Phone + Country */}
              <div className="contact__row">
                <div className="contact__field">
                  <label>Téléphone</label>
                  <input name="phone" value={form.phone} onChange={handleChange} placeholder="+216 XX XXX XXX" />
                </div>
                <div className="contact__field">
                  <label>Pays / Région</label>
                  <input name="country" value={form.country} onChange={handleChange} placeholder="Tunisie, France, ..." />
                </div>
              </div>

              {/* Product Selector */}
              <div className="contact__field contact__field--full">
                <label>Produits Souhaités</label>
                <div className="contact__products">
                  {PRODUCT_CATEGORIES.map(cat => (
                    <div key={cat.group} className="contact__product-group">
                      <button
                        type="button"
                        className="contact__product-group-header"
                        onClick={() => toggleGroup(cat.group)}
                      >
                        <span>{cat.group}</span>
                        <span className={`contact__product-caret ${expandedGroups[cat.group] ? 'open' : ''}`}>▾</span>
                      </button>

                      {expandedGroups[cat.group] && (
                        <div className="contact__subcategories-wrap">
                          {cat.subcategories.map(sub => (
                            <div key={sub.name} className="contact__sub-group">
                              <button
                                type="button"
                                className="contact__sub-group-header"
                                onClick={() => toggleGroup(sub.name)}
                              >
                                <span>{sub.name}</span>
                                <span className={`contact__product-caret ${expandedGroups[sub.name] ? 'open' : ''}`}>▾</span>
                              </button>

                              {expandedGroups[sub.name] && (
                                <div className="contact__product-items">
                                  {sub.items.map(item => (
                                    <label key={item} className="contact__product-check">
                                      <input
                                        type="checkbox"
                                        checked={form.products.includes(item)}
                                        onChange={() => toggleProduct(item)}
                                      />
                                      <span className="contact__checkmark" />
                                      <span>{item}</span>
                                    </label>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {form.products.length > 0 && (
                  <div className="contact__selected-products">
                    {form.products.map(p => (
                      <span key={p} className="contact__selected-tag">
                        {p}
                        <button type="button" onClick={() => toggleProduct(p)}>×</button>
                      </span>
                    ))}
                  </div>
                )}
              </div>

              {/* Quantity */}
              <div className="contact__field contact__field--full">
                <label>Quantité / Précisions</label>
                <textarea name="quantity" value={form.quantity} onChange={handleChange} rows={3} placeholder="Nombre de pièces, dimensions, finitions souhaitées..." />
              </div>

              {/* Message */}
              <div className="contact__field contact__field--full">
                <label>Message *</label>
                <textarea name="message" value={form.message} onChange={handleChange} required rows={5} placeholder="Décrivez votre projet..." />
              </div>

              {/* Source */}
              <div className="contact__field contact__field--full">
                <label>Comment avez-vous connu Khansa Yazidi ?</label>
                <select name="source" value={form.source} onChange={handleChange}>
                  <option value="">— Sélectionner —</option>
                  {SOURCE_OPTIONS.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>

              {error && <p className="contact__error">{error}</p>}

              <button type="submit" className="contact__submit" disabled={sending}>
                {sending ? 'Envoi en cours...' : 'Envoyer la Demande de Devis'}
              </button>
            </form>
          )}
        </div>
      </div>
    </main>
  );
}
